<template>
  <v-dialog
    v-model="openPdfDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    content-class="pdf-dialog-container"
    @keydown.esc="closeDialog"
  >
    <div>
      <v-toolbar dark color="secondary" class="pdf-toolbar">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-tooltip bottom :disabled="zoomValue === 20">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                @click="zoomOut"
                v-bind="attrs"
                v-on="on"
                :disabled="zoomValue === 20"
                class="d-none d-md-flex"
              >
                <v-icon>mdi-minus-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('pdf.zoomOut') }}</span>
          </v-tooltip>
          <v-tooltip bottom :disabled="zoomValue === 100">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                @click="zoomIn"
                v-bind="attrs"
                v-on="on"
                :disabled="zoomValue === 100"
                class="d-none d-md-flex"
              >
                <v-icon>mdi-plus-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('pdf.zoomIn') }}</span>
          </v-tooltip>
          <v-tooltip bottom content-class="pdf-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark @click="downloadFile" v-bind="attrs" v-on="on">
                <v-icon>mdi-download-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('pdf.download') }}</span>
          </v-tooltip>
        </v-toolbar-items>
      </v-toolbar>
      <div class="pdf-content">
        <div class="pdf-loading" v-if="showLoading">
          <v-progress-circular
            :size="70"
            :width="7"
            color="secondary"
            indeterminate
          ></v-progress-circular>
        </div>
        <div class="pdf-viewer" ref="pdfViewer">
          <pdf v-for="i in numPages" :key="i" :src="src" :page="i"></pdf>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import pdf from 'vue-pdf'
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  props: {
    articleId: String,
    articleTitle: String,
    searchTexts: { type: Array, default: () => [] },
    originalId: String
  },
  data() {
    return {
      numPages: undefined,
      src: null,
      zoomValue: 60,
      showLoading: true,
      currentArticle: null,
      dialogTitle: ''
    }
  },
  components: {
    pdf
  },
  computed: {
    ...mapState({
      openPdfDialog: state => state.leaderStore.openPdfDialog,
      selectedPdf: state => state.leaderStore.selectedPdf
    }),
    cvText() {
      return this.$t('reg.cv')
    }
  },
  watch: {
    selectedPdf(newVal) {
      if (newVal && newVal.url) {
        this.startPDF(newVal)
      } else {
        this.clearDialog()
      }
    }
  },
  methods: {
    async startPDF(pdfFile) {
      this.dialogTitle = this.cvText + ' - ' + pdfFile.name
      this.src = await pdf.createLoadingTask(pdfFile.url)

      if (!this.numPages) {
        this.showLoading = true
        this.src.promise.then(item => {
          this.numPages = item.numPages
          setTimeout(() => {
            this.showLoading = false
          }, 2000)
        })
      }
    },
    zoomIn() {
      if (this.zoomValue < 100) {
        this.setZoomValue(this.zoomValue + 10)
      }
    },
    zoomOut() {
      if (this.zoomValue > 20) {
        this.setZoomValue(this.zoomValue - 10)
      }
    },
    setZoomValue(val) {
      this.zoomValue = val
      this.$refs['pdfViewer'].style.maxWidth = this.zoomValue + '%'
    },
    downloadFile() {
      axios({
        url: this.selectedPdf.url,
        method: 'GET',
        responseType: 'blob'
      }).then(response => {
        let fileURL = window.URL.createObjectURL(new Blob([response.data]))
        let fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute(
          'download',
          'CV-' + this.selectedPdf.name + '.pdf'
        )
        document.body.appendChild(fileLink)

        fileLink.click()
      })
    },
    closeDialog() {
      this.$store.dispatch('leaderStore/openPdfDialog', false)
    },
    clearDialog() {
      this.src = null
      this.numPages = undefined
      this.zoomValue = 60
      this.showLoading = true
      this.dialogTitle = ''
    }
  }
}
</script>
<style lang="scss">
.pdf-tooltip {
  @media only screen and (max-width: 960px) {
    display: none !important;
  }
}
.pdf-link {
  text-decoration: none;
  .v-card.pdf-article {
    height: 100%;
    width: 300px;
    text-align: center;
    margin: 0 5px;
    padding: 20px 10px;

    .pdf-image {
      width: 70px;
    }
    .pdf-title {
      margin-bottom: 0;
      font-weight: bold;
      color: #002956;

      &.pdf-title-category {
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      &.pdf-title-result {
        .text__highlight {
          background: #adeeff;
        }
      }
    }
  }
}

.pdf-dialog-container {
  overflow-x: hidden;
  background: #e6e6e6;

  .pdf-toolbar.v-sheet.v-toolbar {
    position: sticky;
    top: 0;
    z-index: 1;
    width: 100%;
  }
  .pdf-content {
    width: 100%;

    .pdf-viewer {
      padding-top: 20px;
      pointer-events: none;
      overflow: auto;
      max-width: 959px;
      margin: auto;

      @media only screen and (min-width: 960px) {
        max-width: 60%;
      }

      > span {
        border: 1px solid #d4d4d4;
        margin-bottom: 10px;
      }
    }
    .pdf-loading {
      text-align: center;
      height: 100px;
      position: fixed;
      top: 180px;
      width: 100%;
      justify-content: center;
    }
  }
}
</style>
